<template>
  <div class="header">
    <div class="name">
      <h3>我的准考证</h3>
      <el-button v-if="dataInfo" size="mini" type="primary" @click="printFunc">
        <div style="display: flex; justify-content: center; align-items: center">
          <Download />
          <span style="margin-left: 5px">下载打印</span>
        </div>
      </el-button>
    </div>
  </div>
  <div style="padding-bottom: 50px" v-if="dataInfo">
    <div style="width: 1000px; margin: 0 auto">
      <table id="pdfDom" width="100%" cellspacing="0" cellpadding="0" border="1">
        <tbody>
          <tr style="border-top: 1px solid transparent !important">
            <td width="10%"></td>
            <td width="11%"></td>
            <td width="7%"></td>
            <td width="8%"></td>
            <td width="2%"></td>
            <td width="6%"></td>
            <td width="6%"></td>
            <td width="50%"></td>
          </tr>
          <tr>
            <td class="title" colspan="7">
              <h2>{{ dataInfo.admissionTitle }}</h2>
            </td>
            <td class="attention" rowspan="10">
              <div>
                <p style="font-weight: 600">注意事项:</p>
                <p style="text-indent: 2em">
                  {{ dataInfo.attention ? dataInfo.attention.replaceAll('\n', '\n\xa0\xa0\xa0\xa0\xa0\xa0') : '' }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td class="basic" colspan="4">姓 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：{{ dataInfo.name }}</td>
            <td class="photo" colspan="3" rowspan="5">
              <img :src="dataInfo.photo || '../assets/resumePhoto.png'" title="考生头像" />
            </td>
          </tr>
          <tr>
            <td class="basic" colspan="4">身份证号：{{ dataInfo.idNumber }}</td>
          </tr>
          <tr>
            <td class="basic" colspan="4">报考单位：{{ dataInfo.deptName }}</td>
          </tr>
          <tr>
            <td class="basic" colspan="4">报考职位：{{ dataInfo.jobName }}</td>
          </tr>
          <tr>
            <td class="basic" colspan="4">考点名称：{{ dataInfo.placeName }}</td>
          </tr>
          <tr>
            <td class="basic" colspan="7">考点地址：{{ dataInfo.placeAddr }}</td>
          </tr>
          <tr>
            <td class="exam">科目</td>
            <td class="exam">日期</td>
            <td class="exam">时间</td>
            <td class="exam" colspan="2 ">准考证号</td>
            <td class="exam">考场号</td>
            <td class="exam">座次号</td>
          </tr>
          <tr class="value">
            <td class="exam">{{ dataInfo.subject }}</td>
            <td class="exam">{{ dataInfo.examDate }}</td>
            <td class="exam">{{ dataInfo.examTime }}</td>
            <td class="exam" colspan="2 ">{{ dataInfo.examNumber }}</td>
            <td class="exam">{{ dataInfo.roomNumber }}</td>
            <td class="exam">{{ dataInfo.seatNumber }}</td>
          </tr>
          <tr>
            <td class="slogan" colspan="7">
              <h3>诚信参考，反对考试作弊，共同维护公平公正！</h3>
              <br />
              <h3>请考生妥善保管好笔试准考证，以备后期使用。</h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <el-empty v-else :image-size="140" description="暂无准考证信息"></el-empty>
</template>

<script>
import { reactive, toRefs, onActivated } from 'vue';
import { Printer, Download } from '@element-plus/icons';
import ApplicantApi from '../service/api/applicant';
import { ElMessage } from 'element-plus';
import printJS from 'print-js';

export default {
  components: { Printer, Download },
  setup() {
    const state = reactive({
      dataInfo: null,
    });

    const init = async () => {
      const basicId = localStorage.getItem('basicId');
      if (!basicId) return;
      try {
        const respond = await ApplicantApi.findMyAdmission({
          basicId: localStorage.getItem('basicId'),
        });
        if (respond) {
          state.dataInfo = respond;
        }
      } catch (error) {
        // ElMessage.warning(error.msg);
      }
    };

    onActivated(init);

    const printFunc = () => {
      // 下载报名表记录到后台
      ApplicantApi.downLoadAdmission({
        basicId: localStorage.getItem('basicId'),
      });
      printJS({
        printable: 'pdfDom',
        type: 'html',
        font_size: '',
        documentTitle: 'zhaopin.hubeidaily.net',
        ignoreElements: ['ignoreTimePrint'],
        maxWidth: 1000,
        targetStyles: ['*'],
        style: '@media print{@page {size:landscape}}',
      });
    };

    return {
      ...toRefs(state),
      printFunc,
    };
  },
};
</script>

<style lang="scss" scoped media="print">
@page {
  size: auto;
  // margin: 40px 50px;
  margin: 5mm;
}

.header {
  border-bottom: 1px solid rgba(112, 112, 112, 0.1);
  box-shadow: 0 0 4px #bebebe;
  padding: 10px 10px 6px 10px;
  font-size: 16px;
  .name {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  h3 {
    flex: 1;
    padding: 0 30px;
  }
}

.el-botton {
  margin-left: 0 !important;
}

.small {
  height: 880px;
  line-height: 30px;
  padding: 0 5px;
}

table {
  margin-top: 40px;
  border: 1px solid #333;
  border-collapse: collapse;
  // font-family: '宋体', SimSun, 'Times New Roman', serif;
  font-size: 14px;
  // margin-left: -10px;
}
.title {
  height: 100px;
  text-align: center;
}
.value {
  font-size: 13px;
}
.attention {
  padding: 20px 6px 20px 10px;
  vertical-align: top;
  letter-spacing: 0.2px;
  line-height: 26px;
  border: 1px solid #333;
}
.basic {
  height: 50px;
  padding-left: 10px;
  border: 1px dashed #ccc;
}
.photo {
  padding: 4px;
  border: 1px dashed #ccc;
  img {
    width: 100%;
    aspect-ratio: 5/7;
    object-fit: contain;
  }
}
.exam {
  height: 50px;
  text-align: center;
  border: 1px solid #333;
}
.slogan {
  height: 150px;
  text-align: center;
}
</style>
